import { cn } from "#app/utils/misc.tsx";
import { Icon } from "./ui/icon.tsx";

interface VoteButtonsProps {
	up: number;
	down: number;
	onUpvote?: () => void;
	onDownvote?: () => void;
	onDisabledClick?: () => void;
	disabled?: boolean;
	size?: "sm" | "md";
}

export function VoteButtons({
	up,
	down,
	onUpvote,
	onDownvote,
	onDisabledClick,
	disabled,
	size = "md",
}: VoteButtonsProps) {
	const interactive = !!onUpvote || !!onDownvote;

	const handleUpvote = () => {
		if (disabled) {
			onDisabledClick?.();
			return;
		}
		onUpvote?.();
	};

	const handleDownvote = () => {
		if (disabled) {
			onDisabledClick?.();
			return;
		}
		onDownvote?.();
	};

	return (
		<div
			className={cn(
				"inline-flex items-center rounded-full border border-border",
				size === "sm" ? "text-xs" : "text-sm",
			)}
		>
			<button
				type="button"
				onClick={interactive || onDisabledClick ? handleUpvote : undefined}
				className={cn(
					"flex items-center gap-1.5 rounded-l-full border-r border-border py-1.5 transition-colors",
					size === "sm" ? "px-2.5" : "px-3.5",
					disabled
						? "cursor-default text-muted-foreground/50"
						: "cursor-pointer text-muted-foreground hover:bg-green-100 hover:text-green-600 dark:hover:bg-green-900/30 dark:hover:text-green-400",
				)}
			>
				<Icon name="thumbs-up" size={size === "sm" ? "sm" : "md"} />
				<span className="font-medium">{up}</span>
			</button>

			<button
				type="button"
				onClick={interactive || onDisabledClick ? handleDownvote : undefined}
				className={cn(
					"flex items-center gap-1.5 rounded-r-full py-1.5 transition-colors",
					size === "sm" ? "px-2.5" : "px-3.5",
					disabled
						? "cursor-default text-muted-foreground/50"
						: "cursor-pointer text-muted-foreground hover:bg-red-100 hover:text-red-600 dark:hover:bg-red-900/30 dark:hover:text-red-400",
				)}
			>
				<Icon name="thumbs-down" size={size === "sm" ? "sm" : "md"} />
				<span className="font-medium">{down}</span>
			</button>
		</div>
	);
}
